import { render } from "./DocumentAcknowledgmentStep.vue?vue&type=template&id=bfa07c08"
import script from "./DocumentAcknowledgmentStep.vue?vue&type=script&lang=js"
export * from "./DocumentAcknowledgmentStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__